import { combineReducers } from "@reduxjs/toolkit";
import practiceReducer from "./user.reducer";
const rootReducer = combineReducers({
    practiceReducer
})

export default rootReducer